<div class="accordion-container">
  <div class="item" *ngFor="let item of items">
    <div class="header" (click)="toggle(item)">
      <h4>{{ item.title }}</h4>
      <i class="fas fa-chevron-down" [class.is-expanded]="item.isExpanded"></i>
    </div>
    <div class="content" [class.is-expanded]="item.isExpanded">
      <p>{{ item.content }}</p>
    </div>
  </div>
</div>
